import axios from 'axios';
import { browserHistory } from 'react-router';
import moment from 'moment-timezone';
import { refreshCurrentUser } from './userActions';

export const RESERVATION_LOADING = 'RESERVATION_LOADING';
export const RESERVATION_ERROR = 'RESERVATION_ERROR';
export const RESERVATION_CREATED = 'RESERVATION_CREATED';
export const CANCEL_BOOKING = 'CANCEL_BOOKING';
export const CANCEL_BOOKING_ERROR = 'CANCEL_BOOKING_ERROR';
export const RESCHEDULE_BOOKING = 'RESCHEDULE_BOOKING';
export const RESCHEDULE_BOOKING_ERROR = 'RESCHEDULE_BOOKING_ERROR';
export const SET_RESCHEDULE_OBJECT = 'SET_RESCHEDULE_OBJECT';
export const CLEAR_RESCHEDULE_OBJECT = 'CLEAR_RESCHEDULE_OBJECT';
export const CLEAR_RESERVATION_ERROR = 'CLEAR_RESERVATION_ERROR';
export const CLEAR_RESCHEDULE_ERROR = 'CLEAR_RESCHEDULE_ERROR';
export const CLEAR_CANCELLATION_ERROR = 'CLEAR_CANCELLATION_ERROR';

export function createReservation(bookingParams, fromSuccess, success, failure) {
  return async (dispatch, getState) => {
    const state = getState();

    const requestData = {
      startTime: bookingParams.startDateTime.format(),
      duration: bookingParams.duration,
      teacherId: bookingParams.teacherId,
      serviceId: bookingParams.serviceId,
      studentTz: moment.tz.guess()
    };

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/appointments`, requestData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(async response => {
        dispatch({
          type: RESERVATION_CREATED,
          payload: response
        });

        if (!fromSuccess) {
          browserHistory.push('/reservations?showSuccess=true');
        }
        // Since minutes left in plan has changed
        dispatch(refreshCurrentUser());
        success && success();
      })
      .catch(result => {
        dispatch({
          type: RESERVATION_ERROR,
          payload: result.response
        });
        failure && failure();
      });
  };
}

export function cancelBooking(appointmentId) {
  return async (dispatch, getState) => {
    const state = getState();

    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/appointments/${appointmentId}/cancel`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.user.token}`
          }
        }
      )
      .then(response => {
        dispatch({
          type: CANCEL_BOOKING,
          id: appointmentId,
          payload: response
        });

        browserHistory.replace('/reservations');
      })
      .catch(result => {
        dispatch({
          type: CANCEL_BOOKING_ERROR,
          id: appointmentId,
          payload: result.response
        });
      });
  };
}

export function rescheduleBooking(bookingParams) {
  return async (dispatch, getState) => {
    const state = getState();

    const requestData = {
      newStartTime: bookingParams.startDateTime.format(),
      newDuration: bookingParams.duration,
      newTeacherId: bookingParams.teacherId,
      newServiceId: bookingParams.serviceId,
      studentTz: moment.tz.guess()
    };

    const originalAppointmentId = bookingParams.originalBooking.id;

    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/appointments/${originalAppointmentId}/reschedule`,
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.user.token}`
          }
        }
      )
      .then(response => {
        dispatch({
          type: RESCHEDULE_BOOKING,
          payload: response
        });

        browserHistory.replace('/reservations');
      })
      .catch(result => {
        dispatch({
          type: RESCHEDULE_BOOKING_ERROR,
          id: originalAppointmentId,
          payload: result.response
        });
        browserHistory.push('/reservations');
      });
  };
}

export function fetchBooking(lessonId, token, success, failure) {
  axios.get(`${process.env.REACT_APP_BACKEND_URL}/appointments/${lessonId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  }).then(response => {
    success && success(response.data.data);
  }).catch(error => {
    failure && failure(error);
  });
}

export function setRescheduleObject(booking) {
  return {
    type: SET_RESCHEDULE_OBJECT,
    payload: booking
  };
}

export function clearRescheduleObject() {
  return {
    type: CLEAR_RESCHEDULE_OBJECT
  };
}

export function clearReservationError() {
  return {
    type: CLEAR_RESERVATION_ERROR
  };
}

export function clearRescheduleError() {
  return {
    type: CLEAR_RESCHEDULE_ERROR
  };
}

export function clearCancellationError() {
  return {
    type: CLEAR_CANCELLATION_ERROR
  };
}

/*
function _sendBookingLimitsExceededError(remainingBookings, remainingMinutes, type) {
  return dispatch => {
    // craft a useful message for the user
    const response = {
      status: 'Limits Violation'
    };

    let message = null;
    if (type === 'daily') {
      message =
        'We are unable to process your request. ' +
        'You have exceeded the daily booking limits for ' +
        'your plan. ' +
        `You are allowed ${remainingBookings} additional ` +
        `booking(s) and ${remainingMinutes} minutes of ` +
        'additional classes on this day. ' +
        'Please select a different day or duration.';
      response.statusText = 'Daily Booking Limits Exceeded';
    } else if (type === 'monthly') {
      message =
        'We are unable to process your request. ' +
        'You have exceeded the monthly booking limits for ' +
        'your plan. ' +
        `You are allowed ${remainingBookings} additional ` +
        'booking(s) on this month.';
      response.statusText = 'Monthly Booking Limits Exceeded';
    }

    dispatch({
      type: RESERVATION_ERROR,
      payload: { message, response }
    });
  };
}

function _sendPlanLimitsError(error) {
  return dispatch => {
    console.log('_sendPlanLimitsError error', error.response, error.message);

    // error already contains a message, but we will override it here
    error.message =
      'We are unable to access your Plan Limits ' +
      'at this time.\nPlease verify that you have ' +
      'selected a language from the Languages filter.  ' +
      'If you still need assistance, email ' +
      'help@rypeapp.com for help.';

    dispatch({
      type: RESERVATION_ERROR,
      payload: error
    });
  };
}
*/



// WEBPACK FOOTER //
// ./src/actions/reservationActions.js